export default __webpack_public_path__ + "static/media/underdelivering.d58a20c3.svg";